import React from "react";

function Hero() {
  return (
    <div className="container">

      {/* Heading */}
      <div className="row py-4 py-md-5 mt-4 mt-md-5 mb-4">
        <div className="col-12">
          <h1 className="fs-3 fs-md-2 text-center px-2">
            We pioneered the discount brokerage model in India.
          </h1>
        </div>
      </div>

      {/* Content */}
      <div
        className="row py-3 py-md-5 border-top text-muted"
        style={{ lineHeight: "1.8" }}
      >

        {/* Left Column */}
        <div className="col-12 col-md-6 mb-4 mb-md-0 px-3 px-md-4">
          <p>
            We kick-started operations on the 15th of August, 2010 with the goal
            of breaking all barriers that traders and investors face in India in
            terms of cost, support, and technology. We named the company
            Zerodha, a combination of Zero and "Rodha", the Sanskrit word for
            barrier.
          </p>

          <p>
            Today, our disruptive pricing models and in-house technology have
            made us the biggest stock broker in India.
          </p>

          <p>
            Over 1+ Crore clients place millions of orders every day through our
            powerful ecosystem of investment platforms, contributing over 15% of
            all Indian retail trading volumes.
          </p>
        </div>

        {/* Right Column */}
        <div className="col-12 col-md-6 px-3 px-md-4">
          <p>
            In addition, we run a number of popular open online educational and
            community initiatives to empower retail traders and investors.
          </p>

          <p>
            Rainmatter, our fintech fund and incubator, has invested in several
            fintech startups with the goal of growing the Indian capital
            markets.
          </p>
        </div>

      </div>
    </div>
  );
}

export default Hero;